/** 5-star rating rendered with Remix Icon glyphs. */
export function Stars({ rating }: { rating: number }) {
  const filled = Math.max(0, Math.min(5, Math.round(rating || 0)));
  return (
    <span className="stars">
      {Array.from({ length: 5 }, (_, i) => (
        <i key={i} className={i < filled ? 'ri-star-fill' : 'ri-star-line'} />
      ))}
    </span>
  );
}
